import { Box, useDisclosure } from '@chakra-ui/react';
import moment from 'moment';
import 'moment/locale/zh-tw';
import { useTranslation } from 'next-i18next';
import EnterButton from './Button/EnterButton';
import { EditOrgClientProfileModal } from './EditOrgClientProfileModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
moment().locale('zh-tw');
export var EditOrgClientProfile = function EditOrgClientProfile(_ref) {
  var _ref$defaultContentWi = _ref.defaultContentWidth,
      defaultContentWidth = _ref$defaultContentWi === void 0 ? '32' : _ref$defaultContentWi,
      children = _ref.children,
      _ref$defaultContent = _ref.defaultContent,
      defaultContent = _ref$defaultContent === void 0 ? false : _ref$defaultContent,
      mobile = _ref.mobile,
      identity_number = _ref.identity_number,
      record_number = _ref.record_number,
      client_id = _ref.client_id,
      profileId = _ref.profileId,
      birthday = _ref.birthday,
      special_note = _ref.special_note,
      allergy_note = _ref.allergy_note,
      gender = _ref.gender,
      real_name = _ref.real_name,
      street = _ref.street,
      country = _ref.country,
      city = _ref.city,
      refetch = _ref.refetch;

  var _useTranslation = useTranslation('common'),
      t = _useTranslation.t;

  var _useDisclosure = useDisclosure(),
      isOpen = _useDisclosure.isOpen,
      onOpen = _useDisclosure.onOpen,
      onClose = _useDisclosure.onClose;

  var hasRecordNo = !!record_number;
  var header = hasRecordNo ? t('common:normal.editPatientData', '病歷資料編輯') : t('common:normal.createPatientID', '建立病歷資料');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [defaultContent && /*#__PURE__*/_jsx(EnterButton, {
      w: defaultContentWidth,
      variant: hasRecordNo ? 'outline' : 'solid',
      handleClick: onOpen,
      e2eid: "components_EditOrgClientProfile_EnterButton",
      children: header
    }), !defaultContent && /*#__PURE__*/_jsx(Box, {
      cursor: "pointer",
      onClick: onOpen,
      e2eid: "components_EditOrgClientProfile_Box",
      children: children
    }), isOpen && /*#__PURE__*/_jsx(EditOrgClientProfileModal, {
      header: header,
      gender: gender,
      birthday: birthday,
      identity_number: identity_number,
      refetchAll: refetch,
      clientId: client_id,
      record_number: record_number,
      profileId: profileId,
      isOpen: isOpen,
      special_note: special_note,
      allergy_note: allergy_note,
      country: country,
      city: city,
      street: street,
      real_name: real_name,
      name: real_name,
      mobile: mobile,
      onClose: onClose,
      e2eid: "components_EditOrgClientProfile_EditOrgClientProfileModal"
    })]
  });
};